var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 2.83235L7.57422 14.8324C7.4697 14.9372 7.34551 15.0204 7.20876 15.0772C7.07202 15.134 6.92541 15.1632 6.77734 15.1632C6.62928 15.1632 6.48267 15.134 6.34592 15.0772C6.20918 15.0204 6.08498 14.9372 5.98047 14.8324L0.730467 9.58235C0.62582 9.47771 0.542809 9.35347 0.486175 9.21674C0.42954 9.08001 0.400391 8.93347 0.400391 8.78548C0.400391 8.63748 0.42954 8.49094 0.486175 8.35421C0.542809 8.21748 0.62582 8.09325 0.730467 7.9886C0.835114 7.88396 0.959348 7.80094 1.09608 7.74431C1.2328 7.68768 1.37935 7.65852 1.52734 7.65852C1.67534 7.65852 1.82188 7.68768 1.95861 7.74431C2.09534 7.80094 2.21957 7.88396 2.32422 7.9886L6.77828 12.4427L17.9823 1.24048C18.1937 1.02913 18.4803 0.9104 18.7792 0.9104C19.0781 0.9104 19.3647 1.02913 19.5761 1.24048C19.7874 1.45182 19.9062 1.73847 19.9062 2.03735C19.9062 2.33624 19.7874 2.62288 19.5761 2.83423L19.5742 2.83235Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck1);
export default __webpack_public_path__ + "static/media/check1.3d8ca38ac11d87024475ac31f0b06863.svg";
export { ForwardRef as ReactComponent };